var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/core-js/library/modules/$.uid.js
 ** module id = 30
 ** module chunks = 2
 **/